import { Alert, AlertType } from 'components/common/alert'
import Company from 'models/company'
import React from 'react'
import styled from 'styled-components'

const StyledAlert = styled(Alert)`
  width: 300px;
  height: 50px;
  font-weight: bold;
  text-align: center;
  border-radius: 0px 0px 10px 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

const StyledAbbr = styled.abbr`
  text-decoration: none !important;
`

export function RoamingAlert({
  company: { id, companyName }
}: {
  readonly company: Company
}): JSX.Element {
  const content = `(${id}) - ${companyName}`

  return (
    <StyledAlert type={AlertType.Warning}>
      <StyledAbbr title={content}>{content}</StyledAbbr>
    </StyledAlert>
  )
}
